<template>
  <div>
    <PublicPageHorizontal
      v-if="isHorizontal()"
      :publicPage="publicPage"
    ></PublicPageHorizontal>
    <PublicPageVertical
      v-else
      :publicPage="publicPage"
    >
    </PublicPageVertical>
  </div>
</template>    

<script>
import PublicPageHorizontal from "./PublicPageHorizontal.vue";
import PublicPageVertical from "./PublicPageVertical.vue";

export default {
  components: {
    PublicPageHorizontal,
    PublicPageVertical,
  },
  props: {
    publicPage: {
      type: Object,
    },
  },
  methods: {
    isHorizontal() {
      return true;
    },
  },
};
</script>